export enum SumsubEventType {
  OnReady = 'OnReady',
  OnInitialized = 'OnInitialized',

  OnStepInitiated = 'OnStepInitiated',
  OnStepCompleted = 'OnStepCompleted',
  OnLivenessCompleted = 'OnLivenessCompleted',

  OnApplicantLoaded = 'OnApplicantLoaded',
  OnApplicantSubmitted = 'OnApplicantSubmitted',
  OnApplicantResubmitted = 'OnApplicantResubmitted',
  OnApplicantStatusChanged = 'OnApplicantStatusChanged',

  OnApplicantActionLoaded = 'OnApplicantActionLoaded',
  OnApplicantActionSubmitted = 'OnApplicantActionSubmitted',
  OnApplicantActionStatusChanged = 'OnApplicantActionStatusChanged',
  OnApplicantActionCompleted = 'OnApplicantActionCompleted',

  ModuleResultPresented = 'ModuleResultPresented',

  OnError = 'OnError',
  OnUploadError = 'OnUploadError',
  OnUploadWarning = 'OnUploadWarning',

  OnResize = 'OnResize',
  OnNavigationUiControlsStateChanged = 'OnNavigationUiControlsStateChanged',

  OnVideoIdentCallStarted = 'OnVideoIdentCallStarted',
  OnVideoIdentModeratorJoined = 'OnVideoIdentModeratorJoined',
  OnVideoIdentCompleted = 'OnVideoIdentCompleted',
}
